// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"0bc83385","612":"15d9d059"}[chunkId] + ".chunk.js";
};